import React from 'react';
import CopyButton from './CopyButton';
import './NFTDetailModal.css';

/* Admin NFT detail card. Shows the FULL owner + contract address (with copy
   buttons) and on-chain metadata. Purely presentational — data comes from the
   NFT object the grid already holds. */
const NFTDetailModal = ({ nft, onClose }) => {
  if (!nft) return null;
  const img = nft.metadata?.image;
  const attrs = Array.isArray(nft.metadata?.attributes) ? nft.metadata.attributes : [];

  return (
    <div className="nftd-overlay" onClick={onClose}>
      <div className="nftd-modal" onClick={(e) => e.stopPropagation()}>
        <button className="nftd-close" type="button" onClick={onClose} aria-label="Close">×</button>

        <div className="nftd-top">
          <div className="nftd-img">
            {img ? (
              <img src={img} alt={nft.metadata?.name || `NFT #${nft.tokenId}`} onError={(e) => { e.currentTarget.style.display = 'none'; }} />
            ) : (
              <div className="nftd-ph">NFT #{nft.tokenId}</div>
            )}
          </div>

          <div className="nftd-head">
            <h3 className="nftd-name">{nft.metadata?.name || `PhoneStream Rig #${nft.tokenId}`}</h3>

            <div className="nftd-row">
              <em>Token ID</em>
              <b>#{nft.tokenId}</b>
            </div>

            <div className="nftd-row">
              <em>Owner</em>
              <span className="nftd-addr">
                {nft.owner ? (
                  <a href={`https://bscscan.com/address/${nft.owner}`} target="_blank" rel="noopener noreferrer">{nft.owner}</a>
                ) : (
                  <span>Unknown</span>
                )}
                {nft.owner && <CopyButton text={nft.owner} label="Copy owner address" />}
              </span>
            </div>

            {nft.contractAddress && (
              <div className="nftd-row">
                <em>Contract</em>
                <span className="nftd-addr">
                  <a href={`https://bscscan.com/token/${nft.contractAddress}?a=${nft.tokenId}`} target="_blank" rel="noopener noreferrer">{nft.contractAddress}</a>
                  <CopyButton text={nft.contractAddress} label="Copy contract address" />
                </span>
              </div>
            )}

            <div className="nftd-stats">
              <div><em>Streams</em><b>{Number(nft.streamingData?.totalStreams || 0).toLocaleString()}</b></div>
              <div><em>Revenue</em><b>${Number(nft.streamingData?.totalRevenue || 0).toFixed(2)}</b></div>
              {nft.isPresale != null && <div><em>Mint</em><b>{nft.isPresale ? 'Presale' : 'Public'}</b></div>}
            </div>
          </div>
        </div>

        {nft.metadata?.description && <p className="nftd-desc">{nft.metadata.description}</p>}

        {attrs.length > 0 && (
          <div className="nftd-attrs">
            {attrs.map((a, i) => (
              <div key={i} className="nftd-attr"><em>{a.trait_type}</em><b>{a.value}</b></div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default NFTDetailModal;
